export const REPORT_FULLSCREEN_MODE_PARAM = 'report_fullscreen_mode';
